import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';

import EventSlide from '../EventSlide';
import EventSlideLarge from '../EventSlideLarge';
import * as Utils from '../../utils';
import { MI_BY_THE_NUMBERS_ID } from '../../constants';

const EventsSlider = ({ events }) => {
  const hasEvents = !!events.length;

  if (!hasEvents) {
    return null;
  }

  const sliderRef = useRef();
  const settings = {
    arrows: false,
    draggable: false,
    swipe: false,
  };
  const handlePrevious = (index) => {
    sliderRef.current.slickGoTo(index - 1);
  };
  const handleNext = (index) => {
    sliderRef.current.slickGoTo(index + 1);
  };
  const handleNextSection = () => {
    Utils.scroll(MI_BY_THE_NUMBERS_ID);
  };

  return (
    <div className='events-slider'>
      <Slider ref={sliderRef} {...settings}>
        {events.map((item, index, items) => {
          const isFirstSlide = index === 0;
          const isLastSlide = index + 1 === items?.length;

          if (isFirstSlide) {
            return (
              <EventSlideLarge
                {...item}
                handleNext={() => handleNext(index)}
                key={`event-slide-${index}`}
              />
            );
          }

          return (
            <EventSlide
              {...item}
              handlePrevious={() => handlePrevious(index)}
              handleNext={() => handleNext(index)}
              handleNextSection={handleNextSection}
              isFirstSlide={isFirstSlide}
              isLastSlide={isLastSlide}
              key={`event-slide-${index}`}
            />
          );
        })}
      </Slider>
    </div>
  );
};

EventsSlider.propTypes = {
  events: PropTypes.array,
};

export default EventsSlider;
